var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTobacco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 28,
    height: 299,
    viewBox: "0 0 28 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "none",
    "data-characteristic": "tobacco",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1055 3.0076C22.1994 2.56661 23.1148 2.7934 24.1055 2.9446C23.5752 3.98199 22.1297 4.03239 21.1055 3.0076Z",
    fill: "#DDCCC9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1055 4.75C20.4032 3.67942 20.5298 3.58283 21.1055 3.92895C20.7233 4.24288 20.4156 4.49644 20.1055 4.75Z",
    fill: "#DDCCC9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78576 13.886C10.9608 13.9878 11.6744 14.6043 12.4894 15.1875C11.5471 15.8726 10.2352 15.2633 9.78576 13.886Z",
    fill: "#DDCCC9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 13.6417C8.85606 12.8218 9.01263 12.793 9.36932 13.3622C8.88648 13.4692 8.49735 13.556 8.106 13.6417Z",
    fill: "#DDCCC9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43664 19.4914C7.24304 18.6307 8.16875 18.4508 9.13095 18.1706C9.08704 19.3348 7.7972 19.9895 6.43664 19.4914Z",
    fill: "#DDCCC9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42123 20.6609C5.24033 19.5645 5.31442 19.4236 5.98233 19.495C5.76799 19.9407 5.59574 20.3002 5.42123 20.6609Z",
    fill: "#DDCCC9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9634 14.9068C22.0983 15.2279 22.6832 15.9677 23.3739 16.6938C22.3195 17.1893 21.1457 16.3441 20.9634 14.9068Z",
    fill: "#DDCCC9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1065 14.5407C19.9974 13.8765 20.1566 13.8776 20.3998 14.5038C19.9055 14.518 19.507 14.5301 19.1065 14.5407Z",
    fill: "#DDCCC9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11593 10.0976C7.97807 9.78701 7.09535 10.1188 6.12899 10.3843C6.77639 11.3529 8.21801 11.2347 9.11593 10.0976Z",
    fill: "#DDCCC9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8938 10.7432C10.4734 9.71457 10.3364 9.63336 9.80498 10.0442C10.2211 10.3115 10.5562 10.5275 10.8938 10.7432Z",
    fill: "#DDCCC9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5985 25.2021C14.9715 24.0831 15.7374 23.5329 16.4945 22.8763C16.9411 23.9524 16.0427 25.0861 14.5985 25.2021Z",
    fill: "#DDCCC9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22302 30.8352C6.48284 29.9169 6.43351 28.9751 6.28994 27.9833C7.43672 28.1888 7.90551 29.5572 7.22302 30.8352Z",
    fill: "#DDCCC9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8671 27.2085C13.2447 26.288 13.2531 26.129 13.8898 25.9149C13.8812 26.4093 13.875 26.808 13.8671 27.2085Z",
    fill: "#DDCCC9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 17.1018C15.0382 16.4847 15.4208 16.1813 15.799 15.8192C16.022 16.4126 15.5733 17.0378 14.8519 17.1018Z",
    fill: "#DDCCC9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 18.2089C14.175 17.7013 14.1792 17.6136 14.4972 17.4955C14.493 17.7682 14.4899 17.988 14.4859 18.2089Z",
    fill: "#DDCCC9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8978 31.7703C17.7227 31.6684 17.0092 31.0519 16.1942 30.4687C17.1365 29.7836 18.4484 30.3929 18.8978 31.7703Z",
    fill: "#DDCCC9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 32.0126C20.2689 32.8325 20.1124 32.8613 19.7557 32.2921C20.2385 32.1851 20.6277 32.0983 21.019 32.0126Z",
    fill: "#DDCCC9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6163 22.7569C10.2433 23.8759 9.47744 24.4261 8.72032 25.0827C8.27378 24.0066 9.17211 22.8729 10.6163 22.7569Z",
    fill: "#DDCCC9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 20.7504C11.9702 21.671 11.9617 21.8299 11.3251 22.0441C11.3336 21.5497 11.3399 21.151 11.3477 20.7504Z",
    fill: "#DDCCC9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 32.2048C13.6337 32.8219 13.2511 33.1253 12.8729 33.4874C12.6498 32.894 13.0986 32.2688 13.82 32.2048Z",
    fill: "#DDCCC9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 31.0977C14.4969 31.6054 14.4927 31.693 14.1746 31.8112C14.1789 31.5385 14.182 31.3186 14.186 31.0977Z",
    fill: "#DDCCC9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22716 38.886C9.40225 38.9878 10.1158 39.6043 10.9308 40.1875C9.9885 40.8726 8.67664 40.2633 8.22716 38.886Z",
    fill: "#DDCCC9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M6.106 38.6417C6.85606 37.8218 7.01263 37.793 7.36932 38.3622C6.88648 38.4692 6.49735 38.556 6.106 38.6417Z",
    fill: "#DDCCC9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5985 42.2021C16.9715 41.0831 17.7374 40.5329 18.4945 39.8763C18.9411 40.9524 18.0427 42.0861 16.5985 42.2021Z",
    fill: "#DDCCC9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8671 44.2085C15.2447 43.288 15.2531 43.129 15.8898 42.9149C15.8812 43.4093 15.875 43.808 15.8671 44.2085Z",
    fill: "#DDCCC9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 39.1018C15.0382 38.4847 15.4208 38.1813 15.799 37.8192C16.022 38.4126 15.5733 39.0378 14.8519 39.1018Z",
    fill: "#DDCCC9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 40.2089C14.175 39.7013 14.1792 39.6136 14.4972 39.4955C14.493 39.7682 14.4899 39.988 14.4859 40.2089Z",
    fill: "#DDCCC9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3392 9.88596C18.1642 9.98783 17.4506 10.6043 16.6356 11.1875C17.5779 11.8726 18.8898 11.2633 19.3392 9.88596Z",
    fill: "#DDCCC9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7064 85.9797C17.5313 86.0816 16.8178 86.6981 16.0028 87.2813C16.9451 87.9664 18.257 87.3571 18.7064 85.9797Z",
    fill: "#DDCCC9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5265 21.2021C14.1535 20.0831 13.3876 19.5329 12.6305 18.8763C12.1839 19.9524 13.0823 21.0861 14.5265 21.2021Z",
    fill: "#DDCCC9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.902 26.8352C22.6422 25.9169 22.6915 24.9751 22.8351 23.9833C21.6883 24.1888 21.2195 25.5572 21.902 26.8352Z",
    fill: "#DDCCC9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2579 23.2085C15.8803 22.288 15.8719 22.129 15.2352 21.9149C15.2438 22.4093 15.25 22.808 15.2579 23.2085Z",
    fill: "#DDCCC9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 13.1018C14.0868 12.4847 13.7042 12.1813 13.326 11.8192C13.103 12.4126 13.5517 13.0378 14.2731 13.1018Z",
    fill: "#DDCCC9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 14.2089C14.95 13.7013 14.9458 13.6136 14.6278 13.4955C14.632 13.7682 14.6351 13.988 14.6391 14.2089Z",
    fill: "#DDCCC9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2272 27.7703C11.4023 27.6684 12.1158 27.0519 12.9308 26.4687C11.9885 25.7836 10.6766 26.3929 10.2272 27.7703Z",
    fill: "#DDCCC9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 28.0126C8.85606 28.8325 9.01263 28.8613 9.36932 28.2921C8.88648 28.1851 8.49735 28.0983 8.106 28.0126Z",
    fill: "#DDCCC9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5087 18.7569C18.8817 19.8759 19.6476 20.4261 20.4047 21.0827C20.8512 20.0066 19.9529 18.8729 18.5087 18.7569Z",
    fill: "#DDCCC9"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 16.7504C17.1548 17.671 17.1633 17.8299 17.7999 18.0441C17.7914 17.5497 17.7851 17.151 17.7773 16.7504Z",
    fill: "#DDCCC9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M15.305 28.2048C15.4913 28.8219 15.8739 29.1253 16.2521 29.4874C16.4752 28.894 16.0264 28.2688 15.305 28.2048Z",
    fill: "#DDCCC9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14.939 27.0977C14.6281 27.6054 14.6323 27.693 14.9504 27.8112C14.9461 27.5385 14.943 27.3186 14.939 27.0977Z",
    fill: "#DDCCC9"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8978 34.886C19.7227 34.9878 19.0092 35.6043 18.1942 36.1875C19.1365 36.8726 20.4484 36.2633 20.8978 34.886Z",
    fill: "#DDCCC9"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M23.019 34.6417C22.2689 33.8218 22.1124 33.793 21.7557 34.3622C22.2385 34.4692 22.6277 34.556 23.019 34.6417Z",
    fill: "#DDCCC9"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5265 38.2021C12.1535 37.0831 11.3876 36.5329 10.6305 35.8763C10.1839 36.9524 11.0823 38.0861 12.5265 38.2021Z",
    fill: "#DDCCC9"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2579 40.2085C13.8803 39.288 13.8719 39.129 13.2352 38.9149C13.2438 39.4093 13.25 39.808 13.2579 40.2085Z",
    fill: "#DDCCC9"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 35.1018C14.0868 34.4847 13.7042 34.1813 13.326 33.8192C13.103 34.4126 13.5517 35.0378 14.2731 35.1018Z",
    fill: "#DDCCC9"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 36.2089C14.95 35.7013 14.9458 35.6136 14.6278 35.4955C14.632 35.7682 14.6351 35.988 14.6391 36.2089Z",
    fill: "#DDCCC9"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7064 49.886C17.5313 49.9878 16.8178 50.6043 16.0028 51.1875C16.9451 51.8726 18.257 51.2633 18.7064 49.886Z",
    fill: "#DDCCC9"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3862 49.6417C19.6361 48.8218 19.4796 48.793 19.1229 49.3622C19.6057 49.4692 19.9948 49.556 20.3862 49.6417Z",
    fill: "#DDCCC9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0556 55.4914C21.2491 54.6307 20.3234 54.4508 19.3612 54.1706C19.4051 55.3348 20.695 55.9895 22.0556 55.4914Z",
    fill: "#DDCCC9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 56.6609C23.2519 55.5645 23.1778 55.4236 22.5099 55.495C22.7242 55.9407 22.8964 56.3002 23.071 56.6609Z",
    fill: "#DDCCC9"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52881 50.9068C6.39387 51.2279 5.809 51.9677 5.11828 52.6938C6.17266 53.1893 7.34648 52.3441 7.52881 50.9068Z",
    fill: "#DDCCC9"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3857 50.5407C8.4948 49.8765 8.3356 49.8776 8.09235 50.5038C8.58669 50.518 8.98522 50.5301 9.3857 50.5407Z",
    fill: "#DDCCC9"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3763 46.0976C20.5141 45.787 21.3968 46.1188 22.3632 46.3843C21.7158 47.3529 20.2742 47.2347 19.3763 46.0976Z",
    fill: "#DDCCC9"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 46.7432C18.0188 45.7146 18.1557 45.6334 18.6872 46.0442C18.2711 46.3115 17.936 46.5275 17.5984 46.7432Z",
    fill: "#DDCCC9"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8936 61.2021C13.5207 60.0831 12.7548 59.5329 11.9977 58.8763C11.5511 59.9524 12.4495 61.0861 13.8936 61.2021Z",
    fill: "#DDCCC9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2692 66.8352C22.0094 65.9169 22.0587 64.9751 22.2022 63.9833C21.0555 64.1888 20.5867 65.5572 21.2692 66.8352Z",
    fill: "#DDCCC9"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6251 63.2085C15.2475 62.288 15.2391 62.129 14.6024 61.9149C14.6109 62.4093 14.6172 62.808 14.6251 63.2085Z",
    fill: "#DDCCC9"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 53.1018C13.454 52.4847 13.0714 52.1813 12.6932 51.8192C12.4702 52.4126 12.9189 53.0378 13.6403 53.1018Z",
    fill: "#DDCCC9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 54.2089C14.3172 53.7013 14.313 53.6136 13.995 53.4955C13.9992 53.7682 14.0023 53.988 14.0063 54.2089Z",
    fill: "#DDCCC9"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59435 67.7703C10.7694 67.6684 11.483 67.0519 12.298 66.4687C11.3557 65.7836 10.0438 66.3929 9.59435 67.7703Z",
    fill: "#DDCCC9"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47319 68.0126C8.22325 68.8325 8.37981 68.8613 8.73651 68.2921C8.25367 68.1851 7.86454 68.0983 7.47319 68.0126Z",
    fill: "#DDCCC9"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 58.7569C18.2489 59.8759 19.0147 60.4261 19.7719 61.0827C20.2184 60.0066 19.3201 58.8729 17.8759 58.7569Z",
    fill: "#DDCCC9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 56.7504C16.522 57.671 16.5304 57.8299 17.1671 58.0441C17.1586 57.5497 17.1523 57.151 17.1445 56.7504Z",
    fill: "#DDCCC9"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6722 68.2048C14.8585 68.8219 15.2411 69.1253 15.6193 69.4874C15.8423 68.894 15.3936 68.2688 14.6722 68.2048Z",
    fill: "#DDCCC9"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3062 67.0977C13.9953 67.6054 13.9995 67.693 14.3175 67.8112C14.3133 67.5385 14.3102 67.3186 14.3062 67.0977Z",
    fill: "#DDCCC9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20.265 74.886C19.0899 74.9878 18.3763 75.6043 17.5614 76.1875C18.5037 76.8726 19.8155 76.2633 20.265 74.886Z",
    fill: "#DDCCC9"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3862 74.6417C21.6361 73.8218 21.4796 73.793 21.1229 74.3622C21.6057 74.4692 21.9948 74.556 22.3862 74.6417Z",
    fill: "#DDCCC9"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8936 78.2021C11.5207 77.0831 10.7548 76.5329 9.99766 75.8763C9.55112 76.9524 10.4495 78.0861 11.8936 78.2021Z",
    fill: "#DDCCC9"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 80.2085C13.2475 79.288 13.2391 79.129 12.6024 78.9149C12.6109 79.4093 12.6172 79.808 12.6251 80.2085Z",
    fill: "#DDCCC9"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 75.1018C13.454 74.4847 13.0714 74.1813 12.6932 73.8192C12.4702 74.4126 12.9189 75.0378 13.6403 75.1018Z",
    fill: "#DDCCC9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 76.2089C14.3172 75.7013 14.313 75.6136 13.995 75.4955C13.9992 75.7682 14.0023 75.988 14.0063 76.2089Z",
    fill: "#DDCCC9"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15294 45.886C10.328 45.9878 11.0416 46.6043 11.8566 47.1875C10.9143 47.8726 9.60242 47.2633 9.15294 45.886Z",
    fill: "#DDCCC9"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47319 45.6417C8.22325 44.8218 8.37981 44.793 8.73651 45.3622C8.25367 45.4692 7.86454 45.556 7.47319 45.6417Z",
    fill: "#DDCCC9"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9657 57.2021C14.3387 56.0831 15.1046 55.5329 15.8617 54.8763C16.3083 55.9524 15.4099 57.0861 13.9657 57.2021Z",
    fill: "#DDCCC9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59021 62.8352C5.85002 61.9169 5.8007 60.9751 5.65713 59.9833C6.80391 60.1888 7.2727 61.5572 6.59021 62.8352Z",
    fill: "#DDCCC9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2343 59.2085C12.6119 58.288 12.6203 58.129 13.2569 57.9149C13.2484 58.4093 13.2422 58.808 13.2343 59.2085Z",
    fill: "#DDCCC9"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2191 49.1018C14.4054 48.4847 14.788 48.1813 15.1662 47.8192C15.3892 48.4126 14.9405 49.0378 14.2191 49.1018Z",
    fill: "#DDCCC9"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8531 50.2089C13.5422 49.7013 13.5464 49.6136 13.8644 49.4955C13.8602 49.7682 13.857 49.988 13.8531 50.2089Z",
    fill: "#DDCCC9"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18.265 63.7703C17.0899 63.6684 16.3763 63.0519 15.5614 62.4687C16.5037 61.7836 17.8155 62.3929 18.265 63.7703Z",
    fill: "#DDCCC9"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3862 64.0126C19.6361 64.8325 19.4796 64.8613 19.1229 64.2921C19.6057 64.1851 19.9948 64.0983 20.3862 64.0126Z",
    fill: "#DDCCC9"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98348 54.7569C9.6105 55.8759 8.84463 56.4261 8.08751 57.0827C7.64096 56.0066 8.53929 54.8729 9.98348 54.7569Z",
    fill: "#DDCCC9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7149 52.7504C11.3374 53.671 11.3289 53.8299 10.6923 54.0441C10.7008 53.5497 10.707 53.151 10.7149 52.7504Z",
    fill: "#DDCCC9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1872 64.2048C13.0008 64.8219 12.6183 65.1253 12.2401 65.4874C12.017 64.894 12.4658 64.2688 13.1872 64.2048Z",
    fill: "#DDCCC9"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 63.0977C13.8641 63.6054 13.8599 63.693 13.5418 63.8112C13.5461 63.5385 13.5492 63.3186 13.5531 63.0977Z",
    fill: "#DDCCC9"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59435 70.886C8.76944 70.9878 9.48303 71.6043 10.298 72.1875C9.35569 72.8726 8.04383 72.2633 7.59435 70.886Z",
    fill: "#DDCCC9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47319 70.6417C6.22325 69.8218 6.37981 69.793 6.73651 70.3622C6.25367 70.4692 5.86454 70.556 5.47319 70.6417Z",
    fill: "#DDCCC9"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9657 74.2021C16.3387 73.0831 17.1046 72.5329 17.8617 71.8763C18.3083 72.9524 17.4099 74.0861 15.9657 74.2021Z",
    fill: "#DDCCC9"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2343 76.2085C14.6119 75.288 14.6203 75.129 15.2569 74.9149C15.2484 75.4093 15.2422 75.808 15.2343 76.2085Z",
    fill: "#DDCCC9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2191 71.1018C14.4054 70.4847 14.788 70.1813 15.1662 69.8192C15.3892 70.4126 14.9405 71.0378 14.2191 71.1018Z",
    fill: "#DDCCC9"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8531 72.2089C13.5422 71.7013 13.5464 71.6136 13.8644 71.4955C13.8602 71.7682 13.857 71.988 13.8531 72.2089Z",
    fill: "#DDCCC9"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3862 85.7355C19.6361 84.9156 19.4796 84.8867 19.1229 85.4559C19.6057 85.5629 19.9948 85.6497 20.3862 85.7355Z",
    fill: "#DDCCC9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0556 91.5852C21.2491 90.7244 20.3234 90.5445 19.3612 90.2644C19.4051 91.4286 20.695 92.0832 22.0556 91.5852Z",
    fill: "#DDCCC9"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 92.7546C23.2519 91.6582 23.1778 91.5173 22.5099 91.5887C22.7242 92.0344 22.8964 92.394 23.071 92.7546Z",
    fill: "#DDCCC9"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52881 87.0005C6.39387 87.3217 5.809 88.0614 5.11828 88.7875C6.17266 89.2831 7.34648 88.4379 7.52881 87.0005Z",
    fill: "#DDCCC9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3857 86.6344C8.4948 85.9703 8.3356 85.9714 8.09235 86.5975C8.58669 86.6117 8.98522 86.6238 9.3857 86.6344Z",
    fill: "#DDCCC9"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3763 82.1914C20.5141 81.8808 21.3968 82.2126 22.3632 82.4781C21.7158 83.4467 20.2742 83.3285 19.3763 82.1914Z",
    fill: "#DDCCC9"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5984 82.837C18.0188 81.8083 18.1557 81.7271 18.6872 82.1379C18.2711 82.4052 17.936 82.6212 17.5984 82.837Z",
    fill: "#DDCCC9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8936 97.2958C13.5207 96.1769 12.7548 95.6266 11.9977 94.9701C11.5511 96.0461 12.4495 97.1798 13.8936 97.2958Z",
    fill: "#DDCCC9"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2692 102.929C22.0094 102.011 22.0587 101.069 22.2022 100.077C21.0555 100.283 20.5867 101.651 21.2692 102.929Z",
    fill: "#DDCCC9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6251 99.3023C15.2475 98.3818 15.2391 98.2228 14.6024 98.0086C14.6109 98.5031 14.6172 98.9017 14.6251 99.3023Z",
    fill: "#DDCCC9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 89.1956C13.454 88.5785 13.0714 88.2751 12.6932 87.913C12.4702 88.5064 12.9189 89.1316 13.6403 89.1956Z",
    fill: "#DDCCC9"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 90.3027C14.3172 89.795 14.313 89.7074 13.995 89.5892C13.9992 89.8619 14.0023 90.0818 14.0063 90.3027Z",
    fill: "#DDCCC9"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59435 103.864C10.7694 103.762 11.483 103.146 12.298 102.562C11.3557 101.877 10.0438 102.487 9.59435 103.864Z",
    fill: "#DDCCC9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47319 104.106C8.22325 104.926 8.37981 104.955 8.73651 104.386C8.25367 104.279 7.86454 104.192 7.47319 104.106Z",
    fill: "#DDCCC9"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8759 94.8507C18.2489 95.9696 19.0147 96.5198 19.7719 97.1764C20.2184 96.1004 19.3201 94.9667 17.8759 94.8507Z",
    fill: "#DDCCC9"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1445 92.8442C16.522 93.7647 16.5304 93.9237 17.1671 94.1379C17.1586 93.6434 17.1523 93.2447 17.1445 92.8442Z",
    fill: "#DDCCC9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6722 104.299C14.8585 104.916 15.2411 105.219 15.6193 105.581C15.8423 104.988 15.3936 104.363 14.6722 104.299Z",
    fill: "#DDCCC9"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3062 103.191C13.9953 103.699 13.9995 103.787 14.3175 103.905C14.3133 103.632 14.3102 103.412 14.3062 103.191Z",
    fill: "#DDCCC9"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20.265 110.98C19.0899 111.082 18.3763 111.698 17.5614 112.281C18.5037 112.966 19.8155 112.357 20.265 110.98Z",
    fill: "#DDCCC9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3862 110.735C21.6361 109.916 21.4796 109.887 21.1229 110.456C21.6057 110.563 21.9948 110.65 22.3862 110.735Z",
    fill: "#DDCCC9"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8936 114.296C11.5207 113.177 10.7548 112.627 9.99766 111.97C9.55112 113.046 10.4495 114.18 11.8936 114.296Z",
    fill: "#DDCCC9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 116.302C13.2475 115.382 13.2391 115.223 12.6024 115.009C12.6109 115.503 12.6172 115.902 12.6251 116.302Z",
    fill: "#DDCCC9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6251 153.16C13.2475 152.239 13.2391 152.08 12.6024 151.866C12.6109 152.361 12.6172 152.759 12.6251 153.16Z",
    fill: "#DDCCC9"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6403 111.196C13.454 110.578 13.0714 110.275 12.6932 109.913C12.4702 110.506 12.9189 111.132 13.6403 111.196Z",
    fill: "#DDCCC9"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0063 112.303C14.3172 111.795 14.313 111.707 13.995 111.589C13.9992 111.862 14.0023 112.082 14.0063 112.303Z",
    fill: "#DDCCC9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15294 81.9797C10.328 82.0816 11.0416 82.6981 11.8566 83.2813C10.9143 83.9664 9.60242 83.3571 9.15294 81.9797Z",
    fill: "#DDCCC9"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.019 9.64172C20.2689 8.82183 20.1124 8.79297 19.7557 9.36217C20.2385 9.46915 20.6277 9.556 21.019 9.64172Z",
    fill: "#DDCCC9"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9657 93.2958C14.3387 92.1769 15.1046 91.6266 15.8617 90.9701C16.3083 92.0461 15.4099 93.1798 13.9657 93.2958Z",
    fill: "#DDCCC9"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M6.59021 98.929C5.85002 98.0106 5.8007 97.0689 5.65713 96.0771C6.80391 96.2825 7.2727 97.6509 6.59021 98.929Z",
    fill: "#DDCCC9"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2343 95.3023C12.6119 94.3818 12.6203 94.2228 13.2569 94.0086C13.2484 94.5031 13.2422 94.9017 13.2343 95.3023Z",
    fill: "#DDCCC9"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2191 85.1956C14.4054 84.5785 14.788 84.2751 15.1662 83.913C15.3892 84.5064 14.9405 85.1316 14.2191 85.1956Z",
    fill: "#DDCCC9"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8531 86.3027C13.5422 85.795 13.5464 85.7074 13.8644 85.5892C13.8602 85.8619 13.857 86.0818 13.8531 86.3027Z",
    fill: "#DDCCC9"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M18.265 99.864C17.0899 99.7622 16.3763 99.1457 15.5614 98.5625C16.5037 97.8774 17.8155 98.4867 18.265 99.864Z",
    fill: "#DDCCC9"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3862 100.106C19.6361 100.926 19.4796 100.955 19.1229 100.386C19.6057 100.279 19.9948 100.192 20.3862 100.106Z",
    fill: "#DDCCC9"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98348 90.8507C9.6105 91.9696 8.84463 92.5198 8.08751 93.1764C7.64096 92.1004 8.53929 90.9667 9.98348 90.8507Z",
    fill: "#DDCCC9"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7149 88.8442C11.3374 89.7647 11.3289 89.9237 10.6923 90.1379C10.7008 89.6434 10.707 89.2447 10.7149 88.8442Z",
    fill: "#DDCCC9"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1872 100.299C13.0008 100.916 12.6183 101.219 12.2401 101.581C12.017 100.988 12.4658 100.363 13.1872 100.299Z",
    fill: "#DDCCC9"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5531 99.1915C13.8641 99.6991 13.8599 99.7868 13.5418 99.9049C13.5461 99.6322 13.5492 99.4124 13.5531 99.1915Z",
    fill: "#DDCCC9"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M7.59435 106.98C8.76944 107.082 9.48303 107.698 10.298 108.281C9.35569 108.966 8.04383 108.357 7.59435 106.98Z",
    fill: "#DDCCC9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47319 106.735C6.22325 105.916 6.37981 105.887 6.73651 106.456C6.25367 106.563 5.86454 106.65 5.47319 106.735Z",
    fill: "#DDCCC9"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9657 110.296C16.3387 109.177 17.1046 108.627 17.8617 107.97C18.3083 109.046 17.4099 110.18 15.9657 110.296Z",
    fill: "#DDCCC9"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2343 112.302C14.6119 111.382 14.6203 111.223 15.2569 111.009C15.2484 111.503 15.2422 111.902 15.2343 112.302Z",
    fill: "#DDCCC9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2191 107.196C14.4054 106.578 14.788 106.275 15.1662 105.913C15.3892 106.506 14.9405 107.132 14.2191 107.196Z",
    fill: "#DDCCC9"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8531 108.303C13.5422 107.795 13.5464 107.707 13.8644 107.589C13.8602 107.862 13.857 108.082 13.8531 108.303Z",
    fill: "#DDCCC9"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78576 121.98C10.9608 122.082 11.6744 122.698 12.4894 123.281C11.5471 123.966 10.2352 123.357 9.78576 121.98Z",
    fill: "#DDCCC9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M9.78576 158.837C10.9608 158.939 11.6744 159.556 12.4894 160.139C11.5471 160.824 10.2352 160.214 9.78576 158.837Z",
    fill: "#DDCCC9"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 121.735C8.85606 120.916 9.01263 120.887 9.36932 121.456C8.88648 121.563 8.49735 121.65 8.106 121.735Z",
    fill: "#DDCCC9"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 158.593C8.85606 157.773 9.01263 157.744 9.36932 158.313C8.88648 158.42 8.49735 158.507 8.106 158.593Z",
    fill: "#DDCCC9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43664 127.585C7.24304 126.724 8.16875 126.545 9.13095 126.264C9.08704 127.429 7.7972 128.083 6.43664 127.585Z",
    fill: "#DDCCC9"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43664 164.443C7.24304 163.582 8.16875 163.402 9.13095 163.122C9.08704 164.286 7.7972 164.941 6.43664 164.443Z",
    fill: "#DDCCC9"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42123 128.755C5.24033 127.658 5.31442 127.517 5.98233 127.589C5.76799 128.034 5.59574 128.394 5.42123 128.755Z",
    fill: "#DDCCC9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42123 165.612C5.24033 164.516 5.31442 164.375 5.98233 164.446C5.76799 164.892 5.59574 165.251 5.42123 165.612Z",
    fill: "#DDCCC9"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9634 123.001C22.0983 123.322 22.6832 124.061 23.3739 124.788C22.3195 125.283 21.1457 124.438 20.9634 123.001Z",
    fill: "#DDCCC9"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9634 159.858C22.0983 160.179 22.6832 160.919 23.3739 161.645C22.3195 162.141 21.1457 161.295 20.9634 159.858Z",
    fill: "#DDCCC9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1065 122.634C19.9974 121.97 20.1566 121.971 20.3998 122.598C19.9055 122.612 19.507 122.624 19.1065 122.634Z",
    fill: "#DDCCC9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1065 159.492C19.9974 158.828 20.1566 158.829 20.3998 159.455C19.9055 159.469 19.507 159.481 19.1065 159.492Z",
    fill: "#DDCCC9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11593 118.191C7.97807 117.881 7.09535 118.213 6.12899 118.478C6.77639 119.447 8.21801 119.328 9.11593 118.191Z",
    fill: "#DDCCC9"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11593 155.049C7.97807 154.738 7.09535 155.07 6.12899 155.336C6.77639 156.304 8.21801 156.186 9.11593 155.049Z",
    fill: "#DDCCC9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8938 118.837C10.4734 117.808 10.3364 117.727 9.80498 118.138C10.2211 118.405 10.5562 118.621 10.8938 118.837Z",
    fill: "#DDCCC9"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8938 155.694C10.4734 154.666 10.3364 154.585 9.80498 154.995C10.2211 155.263 10.5562 155.479 10.8938 155.694Z",
    fill: "#DDCCC9"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5985 133.296C14.9715 132.177 15.7374 131.627 16.4945 130.97C16.9411 132.046 16.0427 133.18 14.5985 133.296Z",
    fill: "#DDCCC9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5985 170.153C14.9715 169.034 15.7374 168.484 16.4945 167.827C16.9411 168.904 16.0427 170.037 14.5985 170.153Z",
    fill: "#DDCCC9"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22302 138.929C6.48284 138.011 6.43351 137.069 6.28994 136.077C7.43672 136.283 7.90551 137.651 7.22302 138.929Z",
    fill: "#DDCCC9"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22302 175.786C6.48284 174.868 6.43351 173.926 6.28994 172.934C7.43672 173.14 7.90551 174.508 7.22302 175.786Z",
    fill: "#DDCCC9"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8671 135.302C13.2447 134.382 13.2531 134.223 13.8898 134.009C13.8812 134.503 13.875 134.902 13.8671 135.302Z",
    fill: "#DDCCC9"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8671 172.16C13.2447 171.239 13.2531 171.08 13.8898 170.866C13.8812 171.361 13.875 171.759 13.8671 172.16Z",
    fill: "#DDCCC9"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 125.196C15.0382 124.578 15.4208 124.275 15.799 123.913C16.022 124.506 15.5733 125.132 14.8519 125.196Z",
    fill: "#DDCCC9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 162.053C15.0382 161.436 15.4208 161.132 15.799 160.77C16.022 161.364 15.5733 161.989 14.8519 162.053Z",
    fill: "#DDCCC9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 126.303C14.175 125.795 14.1792 125.707 14.4972 125.589C14.493 125.862 14.4899 126.082 14.4859 126.303Z",
    fill: "#DDCCC9"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 163.16C14.175 162.652 14.1792 162.565 14.4972 162.447C14.493 162.719 14.4899 162.939 14.4859 163.16Z",
    fill: "#DDCCC9"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8978 139.864C17.7227 139.762 17.0092 139.146 16.1942 138.562C17.1365 137.877 18.4484 138.487 18.8978 139.864Z",
    fill: "#DDCCC9"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8978 176.721C17.7227 176.62 17.0092 176.003 16.1942 175.42C17.1365 174.735 18.4484 175.344 18.8978 176.721Z",
    fill: "#DDCCC9"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 140.106C20.2689 140.926 20.1124 140.955 19.7557 140.386C20.2385 140.279 20.6277 140.192 21.019 140.106Z",
    fill: "#DDCCC9"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 176.964C20.2689 177.784 20.1124 177.812 19.7557 177.243C20.2385 177.136 20.6277 177.049 21.019 176.964Z",
    fill: "#DDCCC9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6163 130.851C10.2433 131.97 9.47744 132.52 8.72032 133.176C8.27378 132.1 9.17211 130.967 10.6163 130.851Z",
    fill: "#DDCCC9"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6163 167.708C10.2433 168.827 9.47744 169.377 8.72032 170.034C8.27378 168.958 9.17211 167.824 10.6163 167.708Z",
    fill: "#DDCCC9"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 128.844C11.9702 129.765 11.9617 129.924 11.3251 130.138C11.3336 129.643 11.3399 129.245 11.3477 128.844Z",
    fill: "#DDCCC9"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 165.702C11.9702 166.622 11.9617 166.781 11.3251 166.995C11.3336 166.501 11.3399 166.102 11.3477 165.702Z",
    fill: "#DDCCC9"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 140.299C13.6337 140.916 13.2511 141.219 12.8729 141.581C12.6498 140.988 13.0986 140.363 13.82 140.299Z",
    fill: "#DDCCC9"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M13.82 177.156C13.6337 177.773 13.2511 178.076 12.8729 178.439C12.6498 177.845 13.0986 177.22 13.82 177.156Z",
    fill: "#DDCCC9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 139.191C14.4969 139.699 14.4927 139.787 14.1746 139.905C14.1789 139.632 14.182 139.412 14.186 139.191Z",
    fill: "#DDCCC9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M14.186 176.049C14.4969 176.557 14.4927 176.644 14.1746 176.762C14.1789 176.49 14.182 176.27 14.186 176.049Z",
    fill: "#DDCCC9"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22716 146.98C9.40225 147.082 10.1158 147.698 10.9308 148.281C9.9885 148.966 8.67664 148.357 8.22716 146.98Z",
    fill: "#DDCCC9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8.22716 183.837C9.40225 183.939 10.1158 184.556 10.9308 185.139C9.9885 185.824 8.67664 185.214 8.22716 183.837Z",
    fill: "#DDCCC9"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M6.106 146.735C6.85606 145.916 7.01263 145.887 7.36932 146.456C6.88648 146.563 6.49735 146.65 6.106 146.735Z",
    fill: "#DDCCC9"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M6.106 183.593C6.85606 182.773 7.01263 182.744 7.36932 183.313C6.88648 183.42 6.49735 183.507 6.106 183.593Z",
    fill: "#DDCCC9"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5985 150.296C16.9715 149.177 17.7374 148.627 18.4945 147.97C18.9411 149.046 18.0427 150.18 16.5985 150.296Z",
    fill: "#DDCCC9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5985 187.153C16.9715 186.034 17.7374 185.484 18.4945 184.827C18.9411 185.904 18.0427 187.037 16.5985 187.153Z",
    fill: "#DDCCC9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8671 152.302C15.2447 151.382 15.2531 151.223 15.8898 151.009C15.8812 151.503 15.875 151.902 15.8671 152.302Z",
    fill: "#DDCCC9"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8671 189.16C15.2447 188.239 15.2531 188.08 15.8898 187.866C15.8812 188.361 15.875 188.759 15.8671 189.16Z",
    fill: "#DDCCC9"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 147.196C15.0382 146.578 15.4208 146.275 15.799 145.913C16.022 146.506 15.5733 147.132 14.8519 147.196Z",
    fill: "#DDCCC9"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8519 184.053C15.0382 183.436 15.4208 183.132 15.799 182.77C16.022 183.364 15.5733 183.989 14.8519 184.053Z",
    fill: "#DDCCC9"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 148.303C14.175 147.795 14.1792 147.707 14.4972 147.589C14.493 147.862 14.4899 148.082 14.4859 148.303Z",
    fill: "#DDCCC9"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4859 185.16C14.175 184.652 14.1792 184.565 14.4972 184.447C14.493 184.719 14.4899 184.939 14.4859 185.16Z",
    fill: "#DDCCC9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3392 117.98C18.1642 118.082 17.4506 118.698 16.6356 119.281C17.5779 119.966 18.8898 119.357 19.3392 117.98Z",
    fill: "#DDCCC9"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3392 154.837C18.1642 154.939 17.4506 155.556 16.6356 156.139C17.5779 156.824 18.8898 156.214 19.3392 154.837Z",
    fill: "#DDCCC9"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 117.735C20.2689 116.916 20.1124 116.887 19.7557 117.456C20.2385 117.563 20.6277 117.65 21.019 117.735Z",
    fill: "#DDCCC9"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M21.019 154.593C20.2689 153.773 20.1124 153.744 19.7557 154.313C20.2385 154.42 20.6277 154.507 21.019 154.593Z",
    fill: "#DDCCC9"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5265 129.296C14.1535 128.177 13.3876 127.627 12.6305 126.97C12.1839 128.046 13.0823 129.18 14.5265 129.296Z",
    fill: "#DDCCC9"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5265 166.153C14.1535 165.034 13.3876 164.484 12.6305 163.827C12.1839 164.904 13.0823 166.037 14.5265 166.153Z",
    fill: "#DDCCC9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M21.902 134.929C22.6422 134.011 22.6915 133.069 22.8351 132.077C21.6883 132.283 21.2195 133.651 21.902 134.929Z",
    fill: "#DDCCC9"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M21.902 171.786C22.6422 170.868 22.6915 169.926 22.8351 168.934C21.6883 169.14 21.2195 170.508 21.902 171.786Z",
    fill: "#DDCCC9"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2579 131.302C15.8803 130.382 15.8719 130.223 15.2352 130.009C15.2438 130.503 15.25 130.902 15.2579 131.302Z",
    fill: "#DDCCC9"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2579 168.16C15.8803 167.239 15.8719 167.08 15.2352 166.866C15.2438 167.361 15.25 167.759 15.2579 168.16Z",
    fill: "#DDCCC9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 121.196C14.0868 120.578 13.7042 120.275 13.326 119.913C13.103 120.506 13.5517 121.132 14.2731 121.196Z",
    fill: "#DDCCC9"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 158.053C14.0868 157.436 13.7042 157.132 13.326 156.77C13.103 157.364 13.5517 157.989 14.2731 158.053Z",
    fill: "#DDCCC9"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 122.303C14.95 121.795 14.9458 121.707 14.6278 121.589C14.632 121.862 14.6351 122.082 14.6391 122.303Z",
    fill: "#DDCCC9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 159.16C14.95 158.652 14.9458 158.565 14.6278 158.447C14.632 158.719 14.6351 158.939 14.6391 159.16Z",
    fill: "#DDCCC9"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2272 135.864C11.4023 135.762 12.1158 135.146 12.9308 134.562C11.9885 133.877 10.6766 134.487 10.2272 135.864Z",
    fill: "#DDCCC9"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2272 172.721C11.4023 172.62 12.1158 172.003 12.9308 171.42C11.9885 170.735 10.6766 171.344 10.2272 172.721Z",
    fill: "#DDCCC9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 136.106C8.85606 136.926 9.01263 136.955 9.36932 136.386C8.88648 136.279 8.49735 136.192 8.106 136.106Z",
    fill: "#DDCCC9"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8.106 172.964C8.85606 173.784 9.01263 173.812 9.36932 173.243C8.88648 173.136 8.49735 173.049 8.106 172.964Z",
    fill: "#DDCCC9"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5087 126.851C18.8817 127.97 19.6476 128.52 20.4047 129.176C20.8512 128.1 19.9529 126.967 18.5087 126.851Z",
    fill: "#DDCCC9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5087 163.708C18.8817 164.827 19.6476 165.377 20.4047 166.034C20.8512 164.958 19.9529 163.824 18.5087 163.708Z",
    fill: "#DDCCC9"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 124.844C17.1548 125.765 17.1633 125.924 17.7999 126.138C17.7914 125.643 17.7851 125.245 17.7773 124.844Z",
    fill: "#DDCCC9"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7773 161.702C17.1548 162.622 17.1633 162.781 17.7999 162.995C17.7914 162.501 17.7851 162.102 17.7773 161.702Z",
    fill: "#DDCCC9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M15.305 136.299C15.4913 136.916 15.8739 137.219 16.2521 137.581C16.4752 136.988 16.0264 136.363 15.305 136.299Z",
    fill: "#DDCCC9"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M15.305 173.156C15.4913 173.773 15.8739 174.076 16.2521 174.439C16.4752 173.845 16.0264 173.22 15.305 173.156Z",
    fill: "#DDCCC9"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M14.939 135.191C14.6281 135.699 14.6323 135.787 14.9504 135.905C14.9461 135.632 14.943 135.412 14.939 135.191Z",
    fill: "#DDCCC9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M14.939 172.049C14.6281 172.557 14.6323 172.644 14.9504 172.762C14.9461 172.49 14.943 172.27 14.939 172.049Z",
    fill: "#DDCCC9"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8978 142.98C19.7227 143.082 19.0092 143.698 18.1942 144.281C19.1365 144.966 20.4484 144.357 20.8978 142.98Z",
    fill: "#DDCCC9"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8978 179.837C19.7227 179.939 19.0092 180.556 18.1942 181.139C19.1365 181.824 20.4484 181.214 20.8978 179.837Z",
    fill: "#DDCCC9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M23.019 142.735C22.2689 141.916 22.1124 141.887 21.7557 142.456C22.2385 142.563 22.6277 142.65 23.019 142.735Z",
    fill: "#DDCCC9"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M23.019 179.593C22.2689 178.773 22.1124 178.744 21.7557 179.313C22.2385 179.42 22.6277 179.507 23.019 179.593Z",
    fill: "#DDCCC9"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5265 146.296C12.1535 145.177 11.3876 144.627 10.6305 143.97C10.1839 145.046 11.0823 146.18 12.5265 146.296Z",
    fill: "#DDCCC9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5265 183.153C12.1535 182.034 11.3876 181.484 10.6305 180.827C10.1839 181.904 11.0823 183.037 12.5265 183.153Z",
    fill: "#DDCCC9"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2579 148.302C13.8803 147.382 13.8719 147.223 13.2352 147.009C13.2438 147.503 13.25 147.902 13.2579 148.302Z",
    fill: "#DDCCC9"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2579 185.16C13.8803 184.239 13.8719 184.08 13.2352 183.866C13.2438 184.361 13.25 184.759 13.2579 185.16Z",
    fill: "#DDCCC9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 143.196C14.0868 142.578 13.7042 142.275 13.326 141.913C13.103 142.506 13.5517 143.132 14.2731 143.196Z",
    fill: "#DDCCC9"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2731 180.053C14.0868 179.436 13.7042 179.132 13.326 178.77C13.103 179.364 13.5517 179.989 14.2731 180.053Z",
    fill: "#DDCCC9"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 144.303C14.95 143.795 14.9458 143.707 14.6278 143.589C14.632 143.862 14.6351 144.082 14.6391 144.303Z",
    fill: "#DDCCC9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6391 181.16C14.95 180.652 14.9458 180.565 14.6278 180.447C14.632 180.719 14.6351 180.939 14.6391 181.16Z",
    fill: "#DDCCC9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTobacco);
export default __webpack_public_path__ + "static/media/tobacco.d51f126766ac5c629e768c540a7854b8.svg";
export { ForwardRef as ReactComponent };